import { render, staticRenderFns } from "./ExcelIcon.vue?vue&type=template&id=735f29a1"
import script from "./ExcelIcon.vue?vue&type=script&lang=ts"
export * from "./ExcelIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports